const PIPEDRIVE_TOKEN = '6c4b755cca73c985a1aeda7caa1c5c650662078e'; // Individual token related to ozge@busuu.com
const EndpointConstant = {
    'hosts': {
        'production': 'https://api.busuu.com',
        'integration-01': 'https://api-integration-01.internal.busuu.com',
        'integration-02': 'https://api-integration-02.internal.busuu.com',
        'integration-03': 'https://api-integration-03.internal.busuu.com',
        'integration-04': 'https://api-integration-04.internal.busuu.com',
        'integration-05': 'https://api-integration-05.internal.busuu.com',
        'integration-06': 'https://api-integration-06.internal.busuu.com',
        'integration-07': 'https://api-integration-07.internal.busuu.com',
        'integration-08': 'https://api-integration-08.internal.busuu.com',
        'integration-09': 'https://api-integration-09.internal.busuu.com',
        'integration-10': 'https://api-integration-10.internal.busuu.com',
        'integration-11': 'https://api-integration-11.internal.busuu.com',
        'integration-12': 'https://api-integration-12.internal.busuu.com',
        'integration-13': 'https://api-integration-13.internal.busuu.com',
        'integration-14': 'https://api-integration-14.internal.busuu.com',
        'integration-15': 'https://api-integration-15.internal.busuu.com',
        'integration-16': 'https://api-integration-16.internal.busuu.com',
        'staging': 'https://api-staging.internal.busuu.com',
        'local': 'https://api-local.internal.busuu.com',
        'dev': 'https://api-dev.internal.busuu.com'
    },
    'endpoints': {
        'register': '/anon/register',
        'registerFacebook': '/anon/register/facebook',
        'registerGoogle': '/anon/register/google',
        'login': '/anon/login',
        'loginFacebook': '/anon/login/facebook',
        'loginGoogle': '/anon/login/google',
        'forgottenPassword': '/anon/forgotten-password',
        'resetPassword': '/anon/reset-password',
        'user': '/users/{uid}',
        'userUpdate': '/users/{uid}',
        'currentUser': '/users/me',
        'courseProgress': '/api/v2/progress/{language}',
        'availablePlans': '/anon/available_plans',
        'availablePlansCoupon': '/anon/available_plans?coupon={coupon}',
        'availablePlansVariants': '/anon/available_plans?variants={variantsIds}',
        'availablePlansVariantsCoupon': '/anon/available_plans?variants={variantsIds}&coupon={coupon}',
        'paymentSessionAvailable': '/zuora/transaction/{busuuTransactionId}?plan_id={planId}',
        'paymentSignature': '/zuora/signature',
        'paymentAfterSubscriptionProcess': '/zuora/process',
        'paymentSepaIframe': '/zuora/hosted_pages/sepa',
        'paymentSepaProcess': '/sepa/process',
        'paymentSepaProcessDiscount': '/sepa/process?coupon={coupon}',
        'paymentTracking': '/subscription/tracking?busuu_transaction_id={busuuTransactionId}&product_plan_id={planId}',
        'paymentPaypalRedirection': '/paypal/redirect?busuu_transaction_id={busuuTransactionId}&product_plan_id={planId}',
        'paymentPaypalRedirectionDiscount': '/paypal/redirect?busuu_transaction_id={busuuTransactionId}&product_plan_id={planId}&coupon={coupon}',
        'autoauth': '/anon/sandbox',
        'autologin': '/anon/login/{type}',
        'feedback': '/anon/users/feedback',
        'feedbackOrg': '/anon/pro/feedback',
        'institutionEmailAssociated': '/anon/invites/find?institution_name={institution_name}&institution_code={institution_code}',
        'voucherRedemption': '/vouchers/redemption',
        'unsubscribe': '/anon/users/unsubscribe?email={email}&user_id={user_id}',
        'studyPlanActivate': '/study_plan/{id}/activate',
        'vivoGetMsisdn': '/terra/landing_page/msisdn',
        'vivoPostService': '/terra/landing_page/pin',
        'vivoPostSubscribe': '/terra/landing_page/subscribe',
        'captcha': '/anon/config?platform=web',
    },
    'absoluteEndpoints': {
        'zuoraAPI': 'https://apisandbox-api.zuora.com/rest/v1/accounts',
        'zuoraProdAPI': 'https://api.zuora.com/rest/v1/accounts',
        'trustpilotBusinnessInfo': 'https://api.trustpilot.com/v1/business-units/{businessId}',
        'trustpilotStarString': 'https://api.trustpilot.com/v1/resources/strings/stars/{stars}',
        'terraGetPhoneNumber': 'https://wstcb-mobile.terra.com/wstcb/Detect.asmx/BrVivoWho',
        'pipedriveCreateDealAPI': `https://busuu.pipedrive.com/v1/deals?api_token=${PIPEDRIVE_TOKEN}`,
        'pipedriveCreateOrgAPI': `https://busuu.pipedrive.com/v1/organizations?api_token=${PIPEDRIVE_TOKEN}`,
        'pipedriveCreatePersonAPI': `https://busuu.pipedrive.com/v1/persons?api_token=${PIPEDRIVE_TOKEN}`
    }
};

module.exports = EndpointConstant;
